import React from "react";
import MainLayout from "./MainLayout";
import TaxSavingPlus from "../common/MainContent/Home/TaxSavingPlus";

const TaxSavingPlusPage = (props) => <MainLayout component={TaxSavingPlus} />;

export default TaxSavingPlusPage;
